import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import $ from 'jquery'
import { Badge } from 'ui'

import { t } from 'translations'

export default function Collapsable({ children, color, show, title, titleVars, type, errors, noPadding, badge }) {
  // Uncollapses the collapsable if there are errors in the fields it contains.
  useEffect(() => {
    if (!Array.isArray(errors)) return
    if (errors.some(error => !isEmpty(error))) {
      $(`#${type}`).collapse('show')
    }
  }, [errors, type])

  return (
    <div className={`collapse-container my-2 ${color}`}>
      <div className="link-toggle toggle-header" data-toggle="collapse" data-target={`#${type}`} aria-expanded={!!show} aria-controls={type}>
        <h6 className="toggle-text align-bottom ">{typeof title === 'object' ? title : <b>{t(title, titleVars)}</b>}</h6>
        {badge ? (
          <Badge variant="primary" className="mr-3">
            {badge}
          </Badge>
        ) : null}
        <i className="fas fa-chevron-up"></i>
        <i className="fas fa-chevron-down"></i>
      </div>
      <div className={`${noPadding ? '' : 'p-3'} collapse${show ? ' show' : ''}`} id={type}>
        {children}
      </div>
    </div>
  )
}

Collapsable.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  titleVars: PropTypes.object,
  type: PropTypes.string.isRequired,
  show: PropTypes.bool,
  color: PropTypes.string
}

Collapsable.defaultProps = {
  titleVars: {},
  color: 'bg-white'
}
